import {TFunction} from "react-i18next";
import {StatementPaymentStatus, StatementType} from "../../../../models/accounting/client-statements";
import {FilterButtonConfig} from "../../../../models/filtered-table/filtered.table.props";

export const filterButtonsFactory = (t: TFunction<"translation">): FilterButtonConfig<any>[] => {
    return [
        {
            text: t('STATEMENTS.FILTERS.ALL'),
            type: 'all',
            filters: []
        },
        {
            text: t('STATEMENTS.FILTERS.UNPAID_INVOICES'),
            type: 'unpaid_invoices',
            filters: [
                {name: 'type', snapshots: [{name: 'type', value: [StatementType.INVOICE]}]},
                {name: 'status', snapshots: [{name: 'status', value: [StatementPaymentStatus.OVERDUE, StatementPaymentStatus.AWAITING]}]},
            ]
        },
        {
            text: t('STATEMENTS.FILTERS.OVERPAID_INVOICES'),
            type: 'overpaid_invoices',
            filters: [
                {name: 'type', snapshots: [{name: 'type', value: [StatementType.INVOICE]}]},
                {name: 'status', snapshots: [{name: 'status', value: [StatementPaymentStatus.OVERPAID]}]},
            ]
        },
        {
            text: t('STATEMENTS.FILTERS.OVERDUE_INVOICES'),
            type: 'overdue_invoices',
            filters: [
                {name: 'type', snapshots: [{name: 'type', value: [StatementType.INVOICE]}]},
                {name: 'status', snapshots: [{name: 'status', value: [StatementPaymentStatus.OVERDUE]}]},
            ]
        }, {
            text: t('STATEMENTS.FILTERS.CREDITS'),
            type: 'credits',
            filters: [
                {name: 'type', snapshots: [{name: 'type', value: [StatementType.CREDIT_INVOICE]}]},
                {name: 'status', snapshots: [{name: 'status', value: [StatementPaymentStatus.AWAITING]}]},
            ]
        }
    ];
}